export default {
    camelCaseToSnakeCase: (camelCaseString) => {
        return camelCaseString.replace(/[a-z][A-Z]/g, (match) => {
            return match.charAt(0) + "_" + match.charAt(1);
        });
    }
};